export default class DataCache<T> {
  private cache = new Map<string | number, { lastUpdated: number; data: T }>()
  private maxAge: number

  constructor(maxAge: number) {
    this.maxAge = maxAge
  }

  async getOrFetch(key: string | number, fetchFn: () => Promise<T>): Promise<T> {
    const cached = this.cache.get(key)

    if (cached && Date.now() - cached.lastUpdated < this.maxAge) {
      return cached.data
    }

    const data = await fetchFn()
    this.cache.set(key, { lastUpdated: Date.now(), data })
    return data
  }

  clear(): void {
    this.cache.clear()
  }
}
